<template>
  <div class="videojs-player">
    <div class="main-body"
         title>
      <div class="player-area"
           v-show="!isError">
        <div class="four-screen player-screen">
          <div :class="[`videobox${index}`,(windowNumber === 1 ? 'one-player' :windowNumber === 4?'four-player':'six-player'), fourFullScreen[index] ? 'full-screen' : '']"
               v-for="(player, index) in playerList"
               :key="index"
               @drop="drop"
               @dragover.prevent
               @dragenter="dragEnter"
               v-loading="player.loding"
               element-loading-text="视频处理中..."
               element-loading-spinner="el-icon-loading"
               @click="onPlayerFocus(index)"
               @dblclick="toggleFullScreen(index)">
            <video :id="`videobox${playOption.playId ? playOption.playId : index}`"
                   :index="index"
                   v-if="showVideoList[index]"
                   class="video-js player"
                   :class="{'player-focus': index === playerIndex}"
                   style="width:100%;height:100%;object-fit: fill;"
                   crossorigin="anonymous"
                   muted
                   :src="videoSrc"
                   type="video/x-flv"
                   preload="auto"
                   :poster="playOption.posterSrc">
              抱歉, 你的浏览器不支持
              <source v-if="mediaType === 'flv'"
                      :src="videoSrc"
                      type="video/x-flv" />
            </video>
            <!-- <span v-if="player.created">
              <i class="el-icon-circle-close close-player"
                 @click.stop="stopVideo(index)"></i>
            </span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-flash'
// import 'videojs-flvjs'
export default {
  name: 'VideojsPlayer',
  props: {
    msg: {
      type: String,
      default: () => ''
    },
    windowNumber: {
      type: Number,
      default: () => 4
    },
    playOption: {
      type: Object,
      default: () => {
        return {
          videoSrc: '',
          posterSrc: ''
        }
      }
    }
  },
  data () {
    return {
      showVideoList: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
      ],
      // videoSrc: 'rtmp://10.40.143.37:1935/live/video1',
      // videoSrc: 'http://nebula-playback.qiniudn.com/test-playback/flv/sample.flv',
      videoSrc: '',
      // posterSrc: 'https://matrimony001.100msh.net.cn/public/code/material/mp-7261-1554175849.jpg',
      isError: false,
      playerIndex: 0,
      key: 0,
      focusIndex: 0,
      mediaType: window.systemConfig.MEDIA_TYPE,
      playerList: [],
      focusVideo: ['', false],
      playerListCopy: [],//备份播放的数据，便宜回显
      keyList: [0, 1, 2, 3, 4, 5,],
      eleCopy: '',
      isDrop: false,
      fourFullScreen: {
        0: false,
        1: false,
        2: false,
        3: false,
      }
    }
  },
  created () {
    if (this.mediaType === 'flv') {
      videojs.options.flash.swf = '/video-js.swf'
    }
    for (let index = 0; index < this.windowNumber; index++) {
      this.playerList.push({ created: false, loding: false })
    }
  },
  mounted () {
  },
  beforeDestroy () {
    // this.close(0)
  },
  methods: {
    dragEnter (e, item) {
      // 摄像机拖入该范围内回调
    },
    dragStart (e) {
      this.isDrop = true
      console.log("开始")
    },
    dragend () {
      console.log("结束")
      this.isDrop = false
    },
    drop (e) {
      // 摄像机放下后回调
      console.log(this.isDrop)
      if (this.isDrop) {
        console.log(e)
      } else {
        let option = e.dataTransfer.getData("item")
        this.$emit('dropCall', JSON.parse(option));
      }
    },
    showTitleBar () { },
    init () {
    },
    onPlayerFocus (index) {
      this.$emit("closeOtherTip")
      if (this.playerIndex > -1) {
        const id = 'videobox' + this.playerIndex + '_flash_api'
        if (document.getElementById(id)) {
          document.getElementById(id).style.border = 'none'
        }
      }
      this.focusVideo = [index, true]
      this.playerIndex = index;
      this.focusIndex = index;
      if (this.playerIndex > -1) {
        const id = 'videobox' + this.playerIndex + '_flash_api';
        if (document.getElementById(id)) {
          document.getElementById(id).style.border = 'none'
        }
      }
      const newId = 'videobox' + this.playerIndex + '_flash_api';
      if (document.getElementById(newId)) {
        document.getElementById(newId).style.border = '2px solid #04c2a0'
      }
      this.$emit('onFocus', this.playerIndex);
      // this.playerList.forEach((item, i) => {
      //     if (index !== i) {
      //         item.isActive = false;
      //     } else {
      //         item.isActive = true;
      //     }
      // })
    },

    toggleFullScreen (index) {
      this.focusVideo = ['', false]
      this.$emit("closeOtherTip")
      if (!this.fourFullScreen[index] && !this.playerList[index].created) {
        this.$message.warning('当前窗口未播放视频，不能放大至全屏');
        return;
      }
      this.fourFullScreen[index] = !this.fourFullScreen[index];

    },
    close (from) {
      const length = this.playerList.length
      const i = from || 0;
      for (let index = from; index < length; index++) {
        if (this['player' + index]) {
          this['player' + index].dispose();
          this['player' + index] = null;
        }

      }
      // if (this['player' + this.playOption.playId]) {
      //   this['player' + this.playOption.playId].dispose();
      //   this['player' + this.playOption.playId] = null;
      // }
    },
    /**
     * 设置窗格布局
     * 布局id     布局描述
     * 41           2*2
     * 92           3*3
     * 11           1
     *  */
    setWndLayout (number) {
      if (number === 1) {
        this.close(1);
        this.playerList.splice(1, this.playerList.length - 1);
        this.fourFullScreen = {
          0: false,
        };
      } else if (number === 4) {
        if (this.playerList.length > 4) {
          // 减少
          this.playerList.splice(4, 2);
        } else {
          this.playerList.push({ created: false, loding: false });
          this.playerList.push({ created: false, loding: false });
          this.playerList.push({ created: false, loding: false });
        }
        this.fourFullScreen = {
          0: false,
          1: false,
          2: false,
          3: false,
        };
      } else if (number === 6) {
        let nineList = [];
        for (let i = 0; i < number - this.playerList.length; i++) {
          nineList.push({ created: false, loding: false });
        }
        this.playerList = this.playerList.concat(nineList)
        this.fourFullScreen = {
          0: false,
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
        };

      }
    },
    startPlay () {
      let index = -1;
      this.playerList.some((item, i) => {
        this.$log.debug('created:', item.created, i)
        if (!item.created) {
          index = i;
          item.created = true;
          return true;
        }
        return false;
      })
      if (index === -1 && this.playerIndex >= 0) {
        index = this.playerIndex;
      }
      // if (index === -1) {
      //     index = 0;
      // }
      // 防止创建播放器后外层焦点无法清除
      if (index === this.playerIndex && this.playerIndex > -1) {
        this.playerIndex = -1;
      }
      if (this.playOption.playId) {
        index = this.playOption.playId
      }
      this.$log.debug('index:' + index);
      this.$log.debug('this.playerIndex:', this.playerIndex);
      this.$log.debug('this.focusIndex:' + this.focusIndex);
      this.$emit('playReady', index)
      this.$nextTick(() => {
        this.startPlay1({ id: 'videobox' + index })
      })
    },
    // 开始播放
    startPlay1 (option,) {
      // var player;
      let _this = this;
      let n = option.id.split('videobox')[1]
      this.$log.debug('startPlay1,option:', option);
      // videojs.options.flash.swf = 'https://64731a8f518e4bd9b7e5df316e8f2e63.apigw.cn-south-1.huaweicloud.com/flv/s1?app=vis&stream=gb-86293214'
      // videojs.options.flash.swf = 'rtmp://127.0.0.1:1935/live/video1'
      let playOption = {
        bigPlayButton: false,
        muted: true,
        loop: true,
        posterImage: true,
        autoplay: true,
        controlBar: false,
        errorDisplay: false,
        textTrackDisplay: false,
        liveTracker: false,
        textTrackSettings: false,
        loadingSpinner: false,
        controls: false
      }
      if (this.mediaType === 'flv') {
        playOption.techOrder = ['flash']
      }
      console.log('====videoSrc===,', _this.videoSrc)
      // setTimeout(() => {
      this['player' + n] = videojs(option.id, playOption, function onPlayerReady () {
        _this.$log.debug('====videoSrc===,', _this.videoSrc);
        // document.getElementById("videobox0").src = '13213/131'
        // this.src({src: _this.playOption.videoSrc, type: 'video/x-flv'});
        this.src(_this.videoSrc);
        // this.src('http://nebula-playback.qiniudn.com/test-playback/flv/sample.flv');
        // this.load();
        this.play();
        this.on('loadstart', function () {
          _this.$log.debug("loadstart");
          this.play();
        });

        this.on('canplay', function () {
          _this.$log.debug("canplay");
          // this.play()
        });
        this.on('pause', function () {
          _this.$log.debug("paused");
          _this.$emit('handlePlayStatus', false);
          // this.play()
        });
        this.on('timeupdate', function () {
          const curTime = this.currentTime();
          const index = this.id_.substring(8, 9)
          // console.log('this.id_-------------', this.id_);
          // console.log('timeupdate-------------', curTime);
          _this.$emit('timeupdate', curTime, index);
        })
        this.on('playing', function (event) {
          _this.$log.debug("playing");
          const index = event.target.id.substring(8, 9)
          _this.$emit('playing', event, index);
          _this.$nextTick(() => {
            if (_this.focusIndex >= 0 && _this.playerIndex === -1) {
              _this.playerIndex = _this.focusIndex;
              const newId = 'videobox' + _this.playerIndex + '_flash_api';
              if (document.getElementById(newId)) {
                document.getElementById(newId).style.border = '2px solid #04c2a0'
              }
            }
          })
        });
        this.on('mouseup', function () {
          // const index = event.target.id.substring(8, 9)
          // if (_this.playerIndex > -1) {
          //     const id = 'videobox' + _this.playerIndex + '_flash_api';
          //     if (document.getElementById(id)) {
          //         document.getElementById(id).style.border = 'none'
          //     }
          // }
          // _this.playerIndex = parseInt(index);
          // _this.focusIndex = parseInt(index);
          // document.getElementById(event.target.id).style.border = '2px solid #04c2a0'
        })
      });
      // }, 500)
    },
    // 停止播放实时画面
    stopLiveVideo () {
    },
    stopVideo (index) {
      this.videoSrc = ""
      this.upVideo(index, '')
    },
    isFillVideoFun () {
      // 判断是否满屏和默认替换最后一个视频
      let isFillVideo = this.playerList.find(el => {
        return !el.created
      })
      return isFillVideo
    },
    // 销毁且重组video
    upVideo (index, url) {
      this.playerList[index].loding = true
      // 切换视频源，+配合选中替换使用 yhjadd
      let eleID = ".videobox" + index;
      var myVideoDiv = document.querySelector(eleID);
      var player = videojs('videobox' + index);
      player.dispose()
      console.log(myVideoDiv)
      console.log(this.videoSrc)
      myVideoDiv.innerHTML = "<video id='testVideo' style='width:100%;height:100%;object-fit: fill' preload='auto' poster='/images/theme/newDark/default.png' class='video-js player vjs-default-skin  vjs-big-play-centered'><source src=" + this.videoSrc + "  type='video/x-flv'/></video>"
      document.getElementById("testVideo").id = "videobox" + index
      this.$nextTick(() => {
        url ? this.playerList[index].created = true : this.playerList[index].created = false
        this.startPlay1({ id: 'videobox' + index })
        setTimeout(() => {
          this.playerList[index].loding = false
        }, 2000)
      })


      // new
      // let eleID = ".videobox" + index;
      // var box = document.querySelector(eleID);//父节点
      // //创建节点
      // var sbox = document.createElement("video");
      // //设置节点id
      // sbox.id = "videobox" + index;
      // //设置节点属性
      // sbox.style.width = '100%';
      // sbox.style.height = '100%';
      // sbox.poster = '/images/theme/newDark/default.png';
      // sbox.preload = 'auto';
      // sbox.class = 'video-js player vjs-default-skin  vjs-big-play-centered';
      // sbox.index = index;
      // sbox.innerHTML = "   <source src='this.videoSrc' type='video/x-flv' />";
      // //插入这个节点
      // var player = videojs('videobox' + index);
      // console.log(box)
      // player.dispose()
      // box.appendChild(sbox);
      // this.$nextTick(() => {
      //   this.videoSrc != "" ? this.playerList[index].created = true : this.playerList[index].created = false
      //   this.startPlay1({ id: 'videobox' + index })
      //   setTimeout(() => {
      //     this.playerList[index].loding = false
      //   }, 2000)
      // })


      // var x = document.createElement("video");
      // x.setAttribute("width", "100%");
      // x.setAttribute("height", "100%");
      // x.setAttribute("id", "testVideo");
      // x.setAttribute("poster", "/images/theme/newDark/default.png");
      // var myVideoDiv = document.querySelector(eleID)
      // myVideoDiv.appendChild(x);

    },
    // 获取直播url并播放
    playLiveVideo (option) {
      // 先判断是否铺满然后判断是否有聚焦且聚焦在本视图区内
      if (this.isFillVideoFun() == undefined) {
        // 铺满
        if (this.focusVideo[1] == true) {
          // 聚焦
          this.focusVideo[0] < this.playerList.length ?
            (this.playerList[this.focusVideo[0]].created = false,
              this.playerList[this.focusVideo[0]].loding = false) : (
              this.playerList[0].created = false,
              this.playerList[0].loding = false,
              this.focusVideo = [0, true]
            )
        } else {
          // 没聚焦
          this.focusVideo = [0, true]
          this.playerList[0].created = false
          this.playerList[0].loding = false
        }
      }
      let index = ""
      this.playerList.some((item, i) => {
        if (!item.created) {
          item.loding = true;
          index = i
          return true;
        }
        return false;
      })
      const param = {
        deviceId: option.thirdCameraId,
        protocol: window.systemConfig.MEDIA_TYPE
      }
      this.$fetch(this.$api.common.video.queryRealTimeVideoRtsp, param).then(res => {
        if (res.success) {
          if (!res.returnObj.url || !res.returnObj.url.length) {
            this.$log.warn('当前摄像机实时视频播放地址为空，摄像机信息为：', param);
            this.$message.warning('播放地址为空')
            return;
          }
          this.videoSrc = res.returnObj.url || this.playOption.videoSrc;
          if (this.isFillVideoFun() == undefined) {
            // 有聚焦
            this.upVideo(this.focusVideo[0], res.returnObj.url)
          } else {
            this.startPlay()
          }
        } else {
          this.$message.error(res.msgContent)
        }
        setTimeout(() => {
          this.playerList[index].loding = false
          index = ""
        }, 500)
      })
    },
    //开始录像回放
    playBackVideo (option) {
      this.$log.debug('handlePlayBackVideo===>', option);
      const param = {
        deviceId: option.deviceId,
        // eventTime: option.eventTime,
        startTime: Math.ceil(option.startTime),
        endTime: Math.ceil(option.endTime)
      }
      this.$fetch(this.$api.common.video.queryPlayBackVideoEventRtsp, param).then(res => {
        if (res.success) {
          if (!res.returnObj.url || !res.returnObj.url.flv) {
            this.$log.warn('当前摄像机录像回放播放地址为空，摄像机信息为：', param);
            this.$message.warning('播放地址为空')
            return;
          }
          this.videoSrc = res.returnObj.url.flv || this.playOption.videoSrc;
          this.startPlay()
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    resetPlayControl () {
      this.close(0);
      this.playerList = [];
      this.$nextTick(() => {
        for (let index = 0; index < this.windowNumber; index++) {
          this.playerList.push({ created: false, loding: false })
        }
      })
    },
    play () {
    },
    resume () {
      if (this.playerIndex > -1) {
        this.$log.debug('resume:', this['player' + this.playerIndex]);
        this['player' + this.playerIndex].play()
      }
    },
    pause () {
      if (this.playerIndex > -1) {
        this.$log.debug('pause:', this['player' + this.playerIndex]);
        this['player' + this.playerIndex].pause()
      }
    },
    requestFullscreen () {
      if (this.playerIndex > -1) {
        this.$log.debug('pause:', this['player' + this.playerIndex]);
        this['player' + this.playerIndex].requestFullscreen()
      }
    },
    localSnap () {
    },
    clear () {
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";
.videojs-player {
  width: 100%;
  height: 100%;
  .main-body {
    width: 100%;
    height: 100%;
    .player-area {
      width: 100%;
      height: 100%;
    }
    .player-screen {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
      .close-player {
        position: absolute;
        font-size: 18px;
        right: 6px;
        top: 8px;
        color: rgb(222, 225, 230);
        cursor: pointer;
        &:hover {
          font-size: 20px;
        }
      }
    }
    .four-player {
      width: 50%;
      height: 50%;
      overflow: hidden;
      display: inline-flex;
      position: relative;

      &.full-screen {
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }
    .one-player {
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: inline-flex;
      position: relative;
    }
    .six-player {
      width: 33%;
      height: 50%;
      overflow: hidden;
      display: inline-flex;
      position: relative;
      &.full-screen {
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }
    .player {
      border-width: 2px;
      border-style: solid;
      // border-color: transparent;
      @include set_theme_color(border-color, content-bg-color);
    }
    .player-focus {
      @include set_theme_color(border-color, active-border-color);
    }
    .video-js {
      object-fit: fill;
      .obj-flash-focus {
        border-width: 2px;
        border-style: solid;
        @include set_theme_color(border-color, active-border-color);
      }
    }
  }
}
</style>
<style>
.videojs-player .vjs-tech {
  pointer-events: none;
}
.vjs-text-track-display {
  display: none;
}
</style>
